import type { FetchOptions } from 'ofetch'

export function getSessionToken(): string {
  if (import.meta.server) return ''
  const value = document.cookie.split('; ').find(value => value.startsWith('truerc_session='))
  return value ? decodeURIComponent(value.slice('truerc_session='.length)) : ''
}

export function clearSessionToken() {
  if (import.meta.client) document.cookie = 'truerc_session=; Max-Age=0; Path=/; SameSite=Strict'
}

export function apiFetch<T = unknown>(request: string, options: FetchOptions<'json'> = {}) {
  const headers = new Headers(options.headers as HeadersInit | undefined)
  const token = getSessionToken()
  if (token) headers.set('Authorization', `Bearer ${token}`)
  return $fetch<T>(request, {
    ...options, headers,
    async onResponseError(context) {
      if (context.response.status === 401 && request !== '/api/login') {
        clearSessionToken()
        if (import.meta.client && window.location.pathname !== '/login') window.location.replace('/login')
      }
    }
  })
}
